import type { PitchFrame } from '@tunasong/plugin-lib'
import type { Entity, PerformancePart, Persisted } from '@tunasong/schemas'
import { normalizeParts } from '@tunasong/schemas'
import { useUserConfig, useUserSettings } from '@tunasong/ui-lib'

/**
 * This person's Perform settings for one song, stored in its private `usersettings` row (D14): the parts
 * override ("This song only") and the Shapes | Concert pitch frame. Absent parts means no override.
 */
export const useSongPerformanceSettings = (song?: Persisted<Entity>) => {
  const { userSettings, setUserSettings, isLoaded } = useUserSettings(song)
  const [musicPreferences] = useUserConfig('musicPreferences')

  const songParts = normalizeParts(userSettings?.parts)
  const frame: PitchFrame | undefined = userSettings?.frame
  /** As `useSyncTransposeFromUserSettings` resolves it for the chord chips, so the header agrees with them */
  const transpose = userSettings?.transpose ?? musicPreferences?.transpose ?? 0

  /** `undefined` deletes the override: a PATCH replaces `settings` whole, and JSON drops the key. */
  const setSongParts = (parts: PerformancePart[] | undefined) => void setUserSettings({ parts })
  const setFrame = (next: PitchFrame) => void setUserSettings({ frame: next })

  return { songParts, frame, transpose, setSongParts, setFrame, isLoaded }
}
